import BaseSVG, { BaseSVGProps } from '../BaseSVG'

export const DatableColoredIcon = (props: BaseSVGProps) => {
  return (
    <BaseSVG {...props} viewBox={`0 0 25 29`} fill="none" stroke="none">
      <path
        d="M6.34696 29C4.61698 29 3.21005 28.3767 2.12583 27.1298C1.04194 25.8832 0.5 24.2158 0.5 22.1268V17.6511C0.5 15.5627 1.04194 13.8946 2.12583 12.6481C3.21005 11.4012 4.61698 10.7779 6.34696 10.7779C7.55124 10.7779 8.5751 11.071 9.41853 11.6568C10.2613 12.2433 10.8802 13.0796 11.2745 14.1664L11.1432 10.1385V5.34296H16.0704V28.6805H11.3074V25.5156C10.913 26.624 10.2892 27.4817 9.43478 28.0891C8.58073 28.6966 7.55124 29 6.34696 29ZM8.25238 24.8442C9.19365 24.8442 9.91138 24.5834 10.4039 24.0608C10.8968 23.5389 11.1432 22.7875 11.1432 21.8072V17.9707C11.1432 16.9907 10.8968 16.2396 10.4039 15.717C9.91138 15.1951 9.19365 14.9336 8.25238 14.9336C7.35423 14.9336 6.65905 15.179 6.16653 15.6689C5.67367 16.1596 5.42724 16.8732 5.42724 17.8109V21.967C5.42724 22.8837 5.67367 23.5925 6.16653 24.0928C6.65905 24.5937 7.35423 24.8442 8.25238 24.8442Z"
        fill="#18343B"
      />
      <path d="M8.20371 0H2.71362V5.34294H8.20371V0Z" fill="#E45128" />
      <path d="M24.5001 0H19.01V5.34294H24.5001V0Z" fill="#C72F0B" />
    </BaseSVG>
  )
}
